var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { UserService } from '../data/user.service';
import { LoggerService } from './logger.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./logger.service";
import * as i3 from "../../app.config";
import * as i4 from "../data/user.service";
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(httpClient, log, config, userService) {
        this.httpClient = httpClient;
        this.log = log;
        this.config = config;
        this.userService = userService;
    }
    Object.defineProperty(AuthenticationService.prototype, "token", {
        get: function () {
            return localStorage.getItem('token');
        },
        set: function (token) {
            if (typeof token !== 'undefined' && token !== null) {
                localStorage.setItem('token', token);
            }
            else {
                localStorage.removeItem('token');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "tokenExpirationDate", {
        get: function () {
            return localStorage.getItem('tokenExpirationDate');
        },
        set: function (tokenExpirationDate) {
            if (typeof tokenExpirationDate !== 'undefined' && tokenExpirationDate !== null) {
                localStorage.setItem('tokenExpirationDate', tokenExpirationDate);
            }
            else {
                localStorage.removeItem('tokenExpirationDate');
            }
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.login = function (userName, password) {
        return __awaiter(this, void 0, void 0, function () {
            var authData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient
                            .post(this.config.apiUrl + "/login", new HttpParams().append('username', userName).append('password', password))
                            .toPromise()];
                    case 1:
                        authData = _a.sent();
                        if (authData) {
                            this.log.debug('AUTH', authData);
                            this.token = authData.token;
                            this.tokenExpirationDate = authData.expire;
                            this.userService.currentUser = authData.account;
                            this.userService.currentUser.groups = authData.groups;
                        }
                        return [2 /*return*/, authData];
                }
            });
        });
    };
    AuthenticationService.prototype.logout = function () {
        this.token = null;
        this.tokenExpirationDate = null;
        this.userService.currentUser = null;
    };
    AuthenticationService.ngInjectableDef = i0.defineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.inject(i1.HttpClient), i0.inject(i2.LoggerService), i0.inject(i3.AppConfig), i0.inject(i4.UserService)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
